import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

// ============================================================================
// Response 타입 (shoebill.ts에서 가져옴)
// ============================================================================

/** 알림 목록 응답 */
export type NotificationListResponse = OAISchema['NotificationListResponse'];

// ============================================================================
// Query Params 타입
// ============================================================================

/**
 * 알림 목록 조회 파라미터
 * @property category - 알림 카테고리: ALL | PRODUCT | EVENT | QUOTE
 */
export type GetNotificationsParams = {
  category: 'ALL' | 'PRODUCT' | 'EVENT' | 'QUOTE';
};

// ============================================================================
// DataSource Interface & Implementation
// ============================================================================

export interface NotificationDataSource {
  /** 알림 목록 조회 */
  getNotifications(
    params: GetNotificationsParams,
  ): Promise<NotificationListResponse>;
}

export class NotificationDataSourceImpl implements NotificationDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getNotifications(params: GetNotificationsParams) {
    return this.client.request<NotificationListResponse>({
      url: '/api/market-place/notifications',
      method: 'get',
      params,
    });
  }
}

export const notificationDataSource = new NotificationDataSourceImpl();
